import { createVuetify } from 'vuetify';
import { useLocalStorage } from '@vueuse/core';

import KitwareMark from '@/src/components/icons/KitwareLogoIcon.vue';
import { DefaultTheme, PycadDarkTheme, ThemeStorageKey } from '@/src/constants';

const vuetify = createVuetify({
  icons: {
    values: {
      kitwareMark: {
        component: KitwareMark,
      },
    },
  },
  defaults: {
    VBtn: { rounded: 'lg' },
    VCard: { rounded: 'lg' },
    VTextField: { variant: 'outlined', density: 'compact' },
    VSelect: { variant: 'outlined', density: 'compact' },
    VSlider: { density: 'compact', color: 'primary' },
    VSwitch: { color: 'primary', density: 'compact' },
    VCheckbox: { color: 'primary', density: 'compact' },
  },
  theme: {
    defaultTheme: DefaultTheme,
    themes: {
      [PycadDarkTheme]: {
        dark: true,
        colors: {
          background: '#000000',
          surface: '#161616',
          'surface-bright': '#161616',
          'surface-variant': '#161616',
          'on-surface-variant': '#a0a0a0',
          primary: '#ff9900',
          'on-primary': '#000000',
          secondary: '#ffffff',
          'on-secondary': '#000000',
          error: '#F87171',
          info: '#3B82F6',
          success: '#4ADE80',
          warning: '#ff9900',
          'on-background': '#ffffff',
          'on-surface': '#ffffff',
          'selection-bg-color': 'rgba(255, 153, 0, 0.18)',
          'selection-border-color': '#ff9900',
          // custom medical plane tokens (consumed via rgb(var(--v-theme-axial)))
          axial: '#3B9EFF',
          sagittal: '#FF5C5C',
          coronal: '#4ADE80',
          'pycad-bg': '#000000',
          'pycad-elevated': '#161616',
          'pycad-border': '#2c2c2c',
          'pycad-text-muted': '#666666',
        },
        variables: {
          'border-color': '#2c2c2c',
          'border-opacity': 1,
          'high-emphasis-opacity': 0.95,
          'medium-emphasis-opacity': 0.7,
          'disabled-opacity': 0.4,
          'theme-overlay-multiplier': 1,
          'theme-kbd': '#111111',
          'theme-on-kbd': '#ffffff',
        },
      },
    },
  },
  display: {
    mobileBreakpoint: 'lg',
    thresholds: {
      lg: 1024,
    },
  },
});

// The SmileSuite design system is dark-only for now. Coerce any previously
// persisted theme (e.g. the old Kitware light theme) back to the default so
// stale localStorage can't leave the app in a broken half-light state.
const KNOWN_THEMES = [PycadDarkTheme];

const theme = useLocalStorage(ThemeStorageKey, DefaultTheme);
if (!KNOWN_THEMES.includes(theme.value)) {
  theme.value = DefaultTheme;
}
vuetify.theme.global.name.value = theme.value;

export default vuetify;
